module.exports = __webpack_public_path__ + "img/result_ls_ceil_angle.91fa693b.jpg";